// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SortLabel--moderator":"fo_a bhs_hm","SortLabel__newFeature":"fo_b bhs_uc bhs_ur"};